import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import Dashboard from '../../../../../layouts/Dashboard';
import styles from './styles';
import { useQuery } from '@apollo/client';
import { GetOrganisationResponse, GetQuestionnaireResponse, getOrganisation, getQuestionnaire } from './queries';
import CustomBackdrop from '../../../../../components/CustomBackdrop';
import EditEraCareQuestionnaireComponent from '../../../../../components/Global/EraCareQuestionnaire/Edit';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
  questionnaire_id: string;
}

const EditEraCareQuestionnaireAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id, questionnaire_id } = useParams<UrlParams>();

  const handleFinish = () => {
    history.push(`/admin/trusts/${organisation_id}/care-questionnaires`);
  };

  const { data: organisationInitQuery, loading } = useQuery<GetOrganisationResponse>(getOrganisation, { variables: { id: organisation_id }, fetchPolicy: 'no-cache' });

  const { data: questionnaireResponse, loading: questionnaireLoading } = useQuery<GetQuestionnaireResponse>(getQuestionnaire, {
    variables: { id: questionnaire_id },
    fetchPolicy: 'no-cache',
  });

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Trusts', link: '/admin/trusts' },
        { label: organisationInitQuery?.organisations_by_pk.name ?? '', link: `/admin/trusts/${organisation_id}` },
        { label: 'Nurtura Questionnaire', link: `/admin/trusts/${organisation_id}/care-questionnaires` },
        { label: questionnaireResponse?.questionnaires_by_pk.name ?? '' },
        { label: 'Edit' },
      ]}>
      <EditEraCareQuestionnaireComponent questionnaireId={questionnaire_id} handleFinish={handleFinish} />
      {(loading || questionnaireLoading) && <CustomBackdrop label="Loading" />}
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(EditEraCareQuestionnaireAdmin));
